export default class Constants {
  static BasePageSegment = 'secured-messaging';
  static BasePagePath = `/${Constants.BasePageSegment}`;

  static NewMessagePageSegment = 'new';
  static NewMessagePagePath = `${Constants.BasePagePath}/${Constants.NewMessagePageSegment}`;

  static MessageDetailsPageSegment = 'details';
  static MessageDetailsPagePath = `${Constants.BasePagePath}/${Constants.MessageDetailsPageSegment}`;

  static NewMessageConfirmationPageSegment = `${Constants.NewMessagePageSegment}/confirmation`;
  static NewMessageConfirmationPagePath = `${Constants.NewMessagePagePath}/confirmation`;
}
